import { render, staticRenderFns } from "./SaleItemsWithGroupByUsername.vue?vue&type=template&id=0146247a&scoped=true"
import script from "./SaleItemsWithGroupByUsername.vue?vue&type=script&lang=js"
export * from "./SaleItemsWithGroupByUsername.vue?vue&type=script&lang=js"
import style0 from "./SaleItemsWithGroupByUsername.vue?vue&type=style&index=0&id=0146247a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0146247a",
  null
  
)

export default component.exports